import { notification } from "antd";
import { get } from "lodash";
import { useState } from "react";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { DOWNLOAD_SINGLE_DOCUMENT } from "utils/api/graphql/mutations/download-document";
import { SIGN_DOCUMENT } from "utils/api/graphql/mutations/esign";
import { ATTACHMENTS } from "utils/api/graphql/queries/attachments";
import {
  DOCUMENTS_TYPES,
  INITIAL_VALUES,
  INSURANCE_PLAN_ATTACHMENTS_TYPES,
} from "utils/constants";
import { SUBSCRIPTION_STEPS } from "../..";
import View from "./View";

const Documents = ({
  subscription,
  onBack,
  updateSubscription,
  totalPrice,
  currentStep,
  setCurrentStep,
}) => {
  const [loading, setLoading] = useState({});
  const [signDocuments] = useMutation(SIGN_DOCUMENT, {
    refetchQueries: [
      {
        query: graphql.queries.SUBSCRIPTION,
        awaitRefetchQueries: true,
        variables: { where: { id: get(subscription, "id") } },
      },
      {
        query: graphql.queries.PROJECTS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
  });
  const [downloadSingleDocument] = useMutation(DOWNLOAD_SINGLE_DOCUMENT);
  const upSells = get(
    subscription,
    `project.fields.upsells.${get(subscription, "insurancePlan.id")}`,
    [],
  );
  const filter = {
    where: {
      OR: [
        ...upSells.map(({ insurancePlan }) => ({
          AND: [
            {
              project: null,
            },
            {
              insurancePlans: {
                id: get(insurancePlan, "id", ""),
              },
            },
          ],
        })),
        {
          AND: [
            {
              project: null,
            },
            {
              insurancePlans: {
                id: get(subscription, "insurancePlan.id", ""),
              },
            },
          ],
        },
        {
          subscription: {
            id: get(subscription, "id"),
          },
        },
        {
          AND: [
            {
              project: {
                id: get(subscription, "project.id"),
              },
            },
            {
              insurancePlans: {
                id: get(subscription, "insurancePlan.id", ""),
              },
            },
          ],
        },
      ],
    },
    isIn: {
      type: [
        ...Object.values(INSURANCE_PLAN_ATTACHMENTS_TYPES),
        DOCUMENTS_TYPES.QUOTE,
        DOCUMENTS_TYPES.MEMBERSHIP_FORM,
        DOCUMENTS_TYPES.CONSENT_FORM,
      ],
    },
  };
  const { data, loading: attachmentsLoading } = useQuery(ATTACHMENTS, {
    variables: filter,
  });

  const handleActivate = () => {
    setLoading((prev) => ({ ...prev, sign: true }));
    signDocuments({
      variables: {
        data: {
          id: get(subscription, "id"),
        },
      },
      onCompleted: () => {
        notification.open({
          message:
            "Votre demande de signature électronique a été envoyée avec succès",
          duration: 5,
          type: "success",
        });
        updateSubscription({
          variables: {
            where: { id: get(subscription, "id") },
            data: {
              additionalInfo: {
                ...get(subscription, "additionalInfo"),
                currentStep: SUBSCRIPTION_STEPS.SIGNATURE_WAITING,
              },
            },
          },
          onCompleted: () => {
            setLoading((prev) => ({ ...prev, sign: false }));
          },
          onError: () => {
            setLoading((prev) => ({ ...prev, sign: false }));
          },
        });
      },
    });
  };

  const handleBack = () => {
    setCurrentStep(SUBSCRIPTION_STEPS.INITIAL);
  };

  if (attachmentsLoading) return <Loading />;

  return (
    <>
      <View
        onBack={handleBack}
        subscription={subscription}
        onSign={handleActivate}
        totalPrice={totalPrice}
        attachments={get(data, "attachments.data")}
        downloadSingleDocument={downloadSingleDocument}
        loading={loading}
        setLoading={setLoading}
      />
    </>
  );
};

export default Documents;
